webpackJsonp([114],{

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".LinkButtons2 .link-buttons{border-width:1px;border-style:none solid solid none}.LinkButtons2 .link-button{border-width:1px;border-style:solid none none solid}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/LinkButtons2/src/components/contents/LinkButtons2/LinkButtons2.s.scss"],"names":[],"mappings":"AAEA,4BAEI,iBAAiB,AACjB,kCAAmC,CACpC,AAJH,2BAMI,iBAAiB,AACjB,kCAAmC,CACpC","file":"LinkButtons2.scss","sourcesContent":["@import '~scss/variables';\n\n.LinkButtons2 {\n  .link-buttons {\n    border-width: 1px;\n    border-style: none solid solid none;\n  }\n  .link-button {\n    border-width: 1px;\n    border-style: solid none none solid;\n  }\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1012);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("619be54d", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/114.492d5973084e8e7f5510.js